import * as yup from "yup";

const validationSchema = yup.object().shape({
  username: yup.string().required("Champs requis"),
});

export default validationSchema;
